// FILECONTENT_START src/common/components/Inputs/DateTimePicker/index.ts
import DateTimePicker from "./DateTimePicker";
export type { DateTimePickerProps } from "./DateTimePicker";
export default DateTimePicker;

// FILECONTENT_END src/common/components/Inputs/DateTimePicker/index.ts